/**
 * The recipient email rule — a mirror of `DOCUMENT_SIGN_EMAIL_PATTERN` in
 * `@fias/db-types` (Zod's own email pattern), which the server applies to every
 * recipient list. `@fias/webapp-client` does not depend on `@fias/db-types`,
 * so the rule is copied here and pinned by
 * `tests/architecture/document-sign-email-rule-parity.test.ts`.
 *
 * One rule, because lists are saved whole: an address the browser accepted
 * but the server refused used to fail every save of a CSV list, silently, over
 * one row the sender could not find. Change both together.
 */
// Kept character-for-character identical to Zod's source (the parity test
// compares `.source`), so its redundant escapes stay.
/* eslint-disable no-useless-escape */
export const RECIPIENT_EMAIL_PATTERN =
  /^(?:[A-Za-z0-9_'+\-]+\.)*[A-Za-z0-9_'+\-]*[A-Za-z0-9_+-]@(?:[A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;
/* eslint-enable no-useless-escape */

/** Whether `email` (already trimmed) is an address the server will accept. */
export function isRecipientEmail(email: string): boolean {
  return RECIPIENT_EMAIL_PATTERN.test(email);
}
